export const initialStateForm = {
  id: null,
  contractorType: 0,
  name: '',
  fullName: '',
  inn: '',
  ogrn: '',
  kpp: '',
  comment: '',
  phone: '',
  email: '',
  isDeleted: false,
  isOwner: false,
  isProvider: false,
  address: '',
  bik: '',
  bankName: '',
  bankAddress: '',
  rs: '',
  ks: '',
  directorName: '',
  directorSurname: '',
  directorMiddleName: '',
  locationType: 0,
};
